var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24.576 5.25107H24.7172C24.5519 4.81439 24.2573 4.43827 23.8725 4.17336C23.4877 3.90846 23.0315 3.76732 22.5644 3.76877H3.15282C2.69008 3.76467 2.2365 3.9005 1.85239 4.15889C1.46806 4.41704 1.17084 4.78566 1 5.21584H1.14114L12.8582 12.3804L24.576 5.25107Z","fill":"#262626","key":0}),React.createElement("path",{"d":"M12.9999 14.7795C12.8021 14.7879 12.6059 14.739 12.4351 14.6381L1.00028 7.68542L1.00028 19.9225C0.990631 20.5339 1.22924 21.1231 1.66158 21.5554C2.09392 21.9877 2.68308 22.2261 3.29423 22.2167H22.7058C23.3169 22.2261 23.9061 21.9877 24.3384 21.5554C24.7708 21.1231 25.0094 20.5339 24.9997 19.9225V7.68542L13.5649 14.6381C13.3921 14.7339 13.1973 14.7824 12.9999 14.7795Z","fill":"#262626","key":1})]);
}

Email.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = Email;

Email.default = Email;
